import { updateField } from 'vuex-map-fields'

const initialState = () => ({
  option2: [
    { step: 0, name: 'Tipo de consulta' },
    { step: 1, name: 'Beneficiário' },
    { step: 2, name: 'Local de atendimento' },
    { step: 3, name: 'Especialidade' },
    { step: 4, name: 'Horário' }
  ],
  option3: [
    { step: 0, name: 'Tipo de consulta' },
    { step: 1, name: 'Termo de uso' },
    { step: 2, name: 'Paciente' },
    { step: 3, name: 'Especialidade' },
    { step: 4, name: 'Horário' }
  ],
  itens: [
    { step: 0, name: 'Tipo de consulta' },
    { step: 1, name: 'Beneficiário' },
    { step: 2, name: 'Especialidade' },
    { step: 3, name: 'Local de atendimento' },
    { step: 4, name: 'Horário' }
  ],
  currentStep: null
})

const state = initialState

const actions = {
  initializeItens ({ commit }) {
    commit('INITIALIZE_ITENS')
  },
  updateIten ({ commit }, payload) {
    commit('UPDATE_ITEM', payload)
  },
  orderItens ({ commit }, payload) {
    commit('ORDER_ITENS', payload)
  },
  restoreNameStep ({ commit }, step) {
    commit('RESTORE_NAME', step)
  }
}

const mutations = {
  updateField,
  UPDATE_ITEM (state, payload) {
    const data = state.itens
    if (payload.value) {
      data[payload.step].name = payload.value
    }
    state.itens = data
    state.currentStep = payload.step
  },
  ORDER_ITENS (state, payload) {
    if (payload.ordem === 2 && payload.idAgenda === '1') {
      state.itens[2] = { step: 2, name: 'Local de atendimento' }
      state.itens[3] = { step: 3, name: 'Especialidade' }
    }
    if (payload.idAgenda === '2') {
      state.itens[1] = { step: 1, name: 'Termo de uso' }
      state.itens[2] = { step: 2, name: 'Paciente' }
      state.itens[3] = { step: 3, name: 'Especialidade' }
    }
  },
  INITIALIZE_ITENS (state) {
    state.currentStep = 0
  },
  SET_CURRENT_STEP (state, payload) {
    state.currentStep = payload
  },
  RESTORE_NAME (state, payload) {
    const defaultSteps = [
      { step: 0, name: 'Tipo de consulta' },
      { step: 1, name: 'Beneficiário' },
      { step: 2, name: 'Especialidade' },
      { step: 3, name: 'Local de atendimento' },
      { step: 4, name: 'Horário' }
    ]
    let data = defaultSteps.find(el => el.step === payload)
    state.itens[payload] = data
  }
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
